const externalArticles = [
  {
    title: "Perché abbiamo bisogno di raccontare le storie? L’esempio di Game of Thrones",
    imageName: "art-lasovsky.jpg",
    link: "https://psiche.santagostino.it/2019/06/19/storie-game-of-thrones/",
  },
  {
    title: "Lei (Her): Una Recensione Psicologica · Psicologo 4U",
    imageName: "her.jpg",
    link: "https://www.psicologo4u.com/lei-her-una-recensione-psicologica/",
  },
  {
    title: "C’mon C’mon: la storia psicologica di Johnny · Psicologo 4U",
    imageName: "cmon-cmon.webp",
    link: "https://www.psicologo4u.com/cmon-cmon-la-storia-psicologica-di-johnny/",
  },
];

export default externalArticles;
